import React, { Fragment, useEffect, useState } from "react"
import { Doughnut } from "react-chartjs";
import { formatMsToTimer } from "../../../utils/formatation";
import { Box, Grid, useMediaQuery } from "@mui/material";
const goDigitalImage = require('../../../images/CTA-SIMULADO.png')


const MyPerformance = ({ data, parseBookType, componente }) => {

    const { result } = data;

    const [componentCaller, setComponentCaller] = useState(null)

    const chartData = [
        {
            value: result.aproveitamento.questoesCorretas,
            color: '#00B47A',
            //label: 'Corretas'
        },
        {
            value: result.aproveitamento.questoesErradas,
            color: '#F27584',
            //label: 'Erradas'
        },
        {
            value: result.aproveitamento.questoesNaoRespondidas,
            color: '#22356C',
            //label: 'Não respondidas'
        }
    ];

    const chartOptions = {
        percentageInnerCutout: 70,
        options: {
            tooltips: {
                enabled: false,
            }
        }
    };

    const parseExamType = (type) => {
        if (type.tipo === 'MODULAR') {
            return 'Modular'
        } else if (type.tipo === 'DIA') {
            return `ENEM ${type.dia}º dia`
        } else {
            return parseBookType(type.caderno).name
        }
    };

    useEffect(() => {
        setComponentCaller(componente);
    }, [])

    const mobile = useMediaQuery('(max-width:900px)');
    return (
        <Fragment>
            <Grid container justifyContent={'center'} spacing={2}>
                <Grid item xs={12}>
                    <Box component={'button'} onClick={() => window.open('https://gex.goexplosion.com/link/checkout?utm=cronograma-beduka-2024')} sx={{ cursor: 'pointer' }}>
                        <img src={goDigitalImage} />
                    </Box>
                </Grid>
            </Grid>
            <h2 className='text-center'><strong>Meu desempenho</strong></h2>
            <section className="exam-type">
                <div className="grid-x grid-margin-x grid-margin-y">
                    <div className="small-12 medium-6 cell">
                        <div className="exam-config-box data-questions">
                            <div className="exam-config-box__icon-area">
                                <i className="icon-modulo" />
                            </div>
                            <div className="exam-config-box__content">
                                <h6 className="primary">{parseExamType(result.tipo)}</h6>
                                <p>{`Aproveitamento de ${result.aproveitamento.total}%`}</p>
                            </div>
                            <div className="exam-config-box__chart">
                                <Doughnut data={chartData} options={chartOptions} height="80" width="100" />
                            </div>

                            <div className="grid-x grid-margin-x colors-legend">
                                <div className="correct-legend small-12 medium-auto cell">
                                    <div className="legend-block" />
                                    <div className="legend-text">
                                        <strong>{result.aproveitamento.questoesCorretas}</strong>{result.aproveitamento.questoesCorretas == 1 ? 'correta' : 'corretas'}
                                    </div>
                                </div>
                                <div className="error-legend small-12 medium-auto cell">
                                    <div className="legend-block" />
                                    <div className="legend-text">
                                        <strong>{result.aproveitamento.questoesErradas}</strong>{result.aproveitamento.questoesErradas == 1 ? 'errada' : 'erradas'}
                                    </div>
                                </div>
                                <div className="noresponse-legend small-12 medium-auto cell">
                                    <div className="legend-block" />
                                    <div className="legend-text">
                                        <strong>{result.aproveitamento.questoesNaoRespondidas}</strong>{result.aproveitamento.questoesNaoRespondidas == 1 ? 'não respondida' : 'não respondidas'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="small-12 medium-6 cell">
                        <div className="exam-config-box data-time">
                            <div className="exam-config-box__icon-area">
                                <i className="icon-tempo" />
                            </div>
                            <div className="exam-config-box__content">
                                <div className="grid-x grid-margin-x align-middle">
                                    <div className="small-12 medium-6 cell">
                                        Tempo gasto no simulado:
                                    </div>
                                    <div className="small-12 medium-6 cell">
                                        <div className="timer-container__timer">
                                            {
                                                componentCaller
                                                    &&
                                                    componentCaller !== 'finished'
                                                    ?
                                                    result.tempoGasto.substring(11, 19)
                                                    :
                                                    formatMsToTimer(result.tempoGasto)
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="grid-x grid-margin-x align-middle">
                                    <div className="small-12 medium-6 cell">
                                        Tempo médio por questão:
                                    </div>
                                    <div className="small-12 medium-6 cell">
                                        <div className="timer-container__timer">
                                            {
                                                componentCaller
                                                    &&
                                                    componentCaller !== 'finished'
                                                    ?
                                                    result.tempoMedioQuestao.substring(11, 19)
                                                    :
                                                    formatMsToTimer(result.tempoMedioQuestao)
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>
    )
}

export default MyPerformance;